import apis from '@/apis'
import EventBus from '@/controllers/EventBus'

// URL and endpoint constants
const PATH_LOGIN = 'authapi/login'
// const PATH_LOGOUT = 'authapi/logout'
const PATH_REGISTER = 'authapi/register'
const PATH_VERIFY = 'users/verify'
const PATH_USERS = 'users'
const PATH_PROJECTS = 'projects'

export default {
  isSecured: true,
  baseUrl: '//noctorus.studio/october/',
  login (creds) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.post(PATH_LOGIN, creds)
      .then(data => {
        EventBus.$emit('authenticated', data)
        resolve(data)
      })
      .catch(error => {
        EventBus.$emit('unauthenticated')
        reject(error)
      })
    })
  },

  register (creds) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.post(PATH_REGISTER, creds)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  logout (context, callback) {
    EventBus.$emit('unauthenticated')
    callback(context)
  },

  verify (token) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get(PATH_VERIFY + '/' + token, {})
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  users () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get(PATH_USERS)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  projects () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get(PATH_PROJECTS)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/Auth.js